import React, {forwardRef} from "react"
import styled from "styled-components";

const StyledInputContainer = styled.div`
    //width: 200px;
    //height:40px;
    height: ${props => props.$height ? props.$height : '40px'};
    width:  ${props => props.$width ? props.$width : '200px'};
    

    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    display: flex;
    align-items: center;
    gap: 5px;
    font: 600 14px/1.5 Pretendard;
    background-color: ${props => props.$readOnly ? '#EEEEEE' : '#FFFFFF'};

    /* margin prop 추가 및 기본값 설정 */
    margin-top: ${props => props.$marginTop || '0'}; 
    margin-bottom: ${props => props.marginBottom || '0'};
    margin-left: ${props => props.$marginLeft || '0'}; 
    margin-right: ${props => props.$marginRight || '0'};

    &:hover,
    &:focus-within {
        border: 1px solid #1C1C1C;
    }

    transition: all 0.3s ease; /* 애니메이션 천천히 */

    input {
        font: 400 15px/1.5 Pretendard;
        flex-grow: 1;
        min-width: 0;
        padding: 0;
        border: none;
        outline: none;
        box-sizing: border-box;

        color: ${props => props.$readOnly ? '#BBBBBB' : '#555555'};;

        &:hover,
        &:focus {
            border: 0;
            outline: none;
        }
    }

    span {
        margin-left: auto;
        white-space: nowrap;
        color: ${props => props.$readOnly ? '#BBBBBB' : '#555555'};;
    }
`;

const InputUnitText = forwardRef(({ type = "text", maxLength, value=""
                                      ,onChange, readOnly=false, unit="",width="200px", height="40px"
                                      , marginTop=0, marginBottom=0, marginLeft=0, marginRight=0 },ref) => {

    const inputMaxLength = maxLength ?? (type === "number" ? 6 : 10);

    const handleInput = (e) => {
        if (e.target.value.length > inputMaxLength) {
            e.target.value = e.target.value.slice(0, inputMaxLength);
        }
    };

    return (
        <StyledInputContainer
            $readOnly={readOnly}
            $marginTop={marginTop}
            $marginBottom={marginBottom}
            $marginLeft={marginLeft}
            $marginRight={marginRight}
            $width={width}
            $height={height}
        >
            <input
                type={type}
                maxLength={inputMaxLength}
                ref={ref}
                readOnly={readOnly}
                value={value || ""}
                onInput={handleInput}
                onChange={(e) => {
                    onChange(e.target.value)
                }}

            />
            {unit && <span>{unit}</span>}
        </StyledInputContainer>
    );
});

export default InputUnitText;